<template>
    <label><input type="checkbox" :checked="value" @change="change"> {{label}}</label>
</template>

<script>
    export default {
    	props:{
            'label':{type:String, default:"Label"},
            'value': {type:Boolean, default:false}
        },
        name: "icheckbox",
        computed: {},
        methods: {
        	change(e){
        		this.$emit('input', e.target.checked);
        	}
        }
    }
</script>

<style scoped>

</style>